module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/round-8105c60eb0afc3e463c951d7467821c6.svg";